var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.909 17.909 0 40 0s40 17.909 40 40-17.909 40-40 40S0 62.091 0 40z",
    fill: "#31A6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 28.67a15.555 15.555 0 01-4.478 1.232 7.842 7.842 0 003.428-4.33 15.6 15.6 0 01-4.95 1.9A7.773 7.773 0 0048.31 25c-4.307 0-7.797 3.503-7.797 7.826 0 .613.069 1.21.202 1.783-6.48-.326-12.224-3.442-16.07-8.177a7.817 7.817 0 00-1.055 3.935 7.831 7.831 0 003.468 6.513 7.735 7.735 0 01-3.53-.978c-.002.033-.002.065-.002.099a7.823 7.823 0 006.255 7.673 7.783 7.783 0 01-3.521.135c.991 3.109 3.87 5.371 7.282 5.434a15.604 15.604 0 01-9.682 3.35c-.63 0-1.25-.037-1.86-.108A22.01 22.01 0 0033.951 56c14.34 0 22.181-11.926 22.181-22.267 0-.34-.007-.677-.022-1.013A15.845 15.845 0 0060 28.67z",
    fill: "#fff"
  })));
}
export default SvgTwitter;